import { AppError } from '@lessonup/utils-support';
import { LoggerTransport } from '../loggerTransport';

type TrackFunction = (error: string | Error | AppError) => void;

/**
 * Transport to track errors going through the logger
 */
export class TrackErrorTransport implements LoggerTransport {
  public constructor(private readonly track: TrackFunction) {}

  public debug(): void {
    // Do nothing
  }

  public info(): void {
    // Do nothing
  }

  public warn(): void {
    // Do nothing
  }

  public error(message: string | Error | AppError): void {
    this.track(message);
  }
}
